/** Ignore taps and predominantly vertical scrolling; keep navigation within the queue. */
export function swipeOrderIndex(dx: number, dy: number, currentIndex: number, orderCount: number): number {
  if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5) return currentIndex;
  return Math.max(0, Math.min(orderCount - 1, currentIndex + (dx < 0 ? 1 : -1)));
}
